module.exports = __webpack_public_path__ + "img/export1.64cfca87.png";